<template>
  <div class="seller-detail-page">

    <div class="sellerinfo">
      <el-row>
        <el-col :span="16" :class="'shopnameinfo ' + details.logoimg">
          <h1 class="shopnametxt">{{ details.ShopName }}</h1>
          <h2 class="shopidtxt">ID：{{ details.ShopId }}</h2>
        </el-col>
        <el-col :span="8">
          <!-- <span style="float:right; font-size:14px;">{{$t("charts.latestupdate")}}：{{ details.update }}</span> -->
        </el-col>
      </el-row>
    </div>
    
    <div class="sellerbaseinfobox">
      <el-descriptions :column="3" border size="small">
          <el-descriptions-item :label="$t('Seller.t11')">
            <el-rate
              v-model="details.shopLevel"
              disabled
              show-score
              text-color="#ff9900"
              score-template="{value}">
            </el-rate>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('Seller.t16')">
            <el-rate
              class="platformlevelcolors"
              v-model="details.channelLevel"
              disabled
              show-score
              :colors="['#4169E1', '#4169E1', '#4169E1']"
              text-color="#4169E1"
              score-template="{value}">
            </el-rate>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('Seller.t17')">{{ details.ShopCredit }}</el-descriptions-item>

          <el-descriptions-item :label="$t('Seller.t18')">{{ details.tsCount }}</el-descriptions-item>
          <el-descriptions-item :label="$t('Seller.t19')">{{ details.cgCount }}</el-descriptions-item>
          <el-descriptions-item :label="$t('Seller.t20')">{{ details.tsTime }}</el-descriptions-item>

          <el-descriptions-item :label="$t('dsfx.t23')">{{ details.isAuth }}</el-descriptions-item>
          <el-descriptions-item :label="$t('jgjk.s211')">{{ details.shopLab }}</el-descriptions-item>
          <el-descriptions-item :label="$t('Seller.t21')">{{ details.isYjdf }}</el-descriptions-item>

          <el-descriptions-item :label="$t('Seller.t22')">{{ details.fansNum }}</el-descriptions-item>
          <el-descriptions-item :label="$t('Seller.t23')">{{ details.weiXin }}</el-descriptions-item>
          <el-descriptions-item :label="$t('Seller.t24')">{{ details.weibo }}</el-descriptions-item>

          <el-descriptions-item :label="$t('Seller.t25')">{{ details.sellerName }}</el-descriptions-item>
          <el-descriptions-item :label="$t('Seller.t26')" span="2">{{ details.mobile }}</el-descriptions-item>

          <el-descriptions-item :label="$t('Seller.t27')" span="3">{{ details.ShopAddress }}</el-descriptions-item>
      </el-descriptions>
    </div>

  </div>
</template>

<script>
export default {

  props: {
    details: Object
  },

  mounted(){
  },

  methods: {
  }

}
</script>

<style>
.sellerbaseinfobox .el-descriptions-item__content{
  width: 170px;
}
</style>